import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type ManagerAuthContextValue = {
  getAccessToken: () => Promise<string | undefined>;
  standort: { id: string; name: string };
};

const ManagerAuthContext = createContext<ManagerAuthContextValue | undefined>(
  undefined,
);

export function ManagerAuthProvider({
  value,
  children,
}: {
  value: ManagerAuthContextValue;
  children: ReactNode;
}) {
  return (
    <ManagerAuthContext.Provider value={value}>
      {children}
    </ManagerAuthContext.Provider>
  );
}

// oxlint-disable-next-line react/only-export-components
export function useManagerAuth(): ManagerAuthContextValue {
  const context = useContext(ManagerAuthContext);

  if (context === undefined) {
    throw new Error(
      'useManagerAuth must be used within an ManagerAuthProvider',
    );
  }

  return context;
}
